"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./EmptyState.css");
var Title_1 = __importDefault(require("../Title"));
var Button_1 = __importDefault(require("../Button"));
var Link_1 = __importDefault(require("../Link"));
function EmptyState(_a) {
    var image = _a.image, title = _a.title, primaryActionLabel = _a.primaryActionLabel, secondaryActionLabel = _a.secondaryActionLabel, onClickPrimary = _a.onClickPrimary, onClickSecondary = _a.onClickSecondary, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, children = _a.children;
    var classname = fullWidth
        ? "nimbus--empty-state is-full-width"
        : "nimbus--empty-state";
    var renderTitle = title && (React.createElement("div", { className: "nimbus--empty-state__heading" },
        React.createElement(Title_1.default, { type: "h2" }, title)));
    var renderPrimary = primaryActionLabel && onClickPrimary && (React.createElement("div", { className: "nimbus--action-wrapper__item" },
        React.createElement(Button_1.default, { onClick: onClickPrimary, appearance: "primary" }, primaryActionLabel)));
    var renderSecondary = secondaryActionLabel && onClickSecondary && (React.createElement("div", { className: "nimbus--action-wrapper__item" },
        React.createElement(Link_1.default, { onClick: onClickSecondary, appearance: "primary" }, secondaryActionLabel)));
    return (React.createElement("div", { className: classname },
        React.createElement("div", { className: "nimbus--empty-state__image" },
            React.createElement("img", { src: image, alt: title })),
        React.createElement("div", { className: "nimbus--empty-state__content" },
            renderTitle,
            React.createElement("div", { className: "nimbus--empty-state__body" }, children),
            React.createElement("div", { className: "nimbus--action-wrapper" },
                renderPrimary,
                renderSecondary))));
}
exports.default = EmptyState;
//# sourceMappingURL=index.js.map